<template>
<div v-if="loader">
      <img
        src="../../../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
  <div v-else>
    <div class="sa-mob-cont">
      <button class="sa-btn-back" @click="$parent.referHemo = false">
        <i class="icon-arrow-left"></i>
      </button>
      <h6 class="sa-card-tit sa-ref-tit">Refer to Hemodialysis</h6>
      <div class=" sa-h-sm-up">
        <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg3"> -->
          <div class="sa-form-group">
           
            <input
              type="text"
              class="sa-form-control sa-search-lft"
              id="searchName"
              name="Search Name"
              v-model="searchName"
              placeholder="Search"
            />
             <i class="icon-search sa-search-icn"></i>
          <!-- </div> -->
        </div>
      </div>
      <ul class="sa-nurse-list">
        <li v-for="(hemo, i) in heamoList" :key="i">
          <input
            type="checkbox"
            :id="hemo.tsk_id"
            :name="hemo.tsk_nm"
            :value="hemo.tsk_id"
            v-model="selected"
          />
          <label :for="hemo.tsk_id">
            <figure class="sa-avtar sa-avtar-lg">
              <img
                :src="hemo.tsk_img"
                alt="Doctor"
                class="sa-img-cover"
              />
            </figure>
            <span class="sa-nurse-cnt"
              ><strong>{{hemo.tsk_nm}}</strong
              ><small class="sa-d-block"
                >{{Array.prototype.map.call(hemo.inclsn, function(item) { return item; }).join(",")}}</small
              ></span
            >
          </label>
        </li>
      </ul>
    </div>
    <div class="sa-ftr-btn">
      <button :disabled="selected && selected.length <= 0" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs" @click="referHemodialysis()">
        Continue
      </button>
    </div>
  </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
export default {
  props: ["hemo"],
  methods: {
     referHemodialysis () {
        this.loader = true
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        _self.$store.dispatch('httpPost', {
            uri: `${pro_url}/refer/addTreatmentReferal`,
            body:{
            "apnt_id": _self.patDetails.apnt_id,
            // "pid": _self.patDetails.pid,
            "uid": _self.patDetails.refDoctor || "",
            stid: _self.patDetails.stid || '',
            dept_id: _self.patDetails.dept_id || '',
            "pkg_id": _self.patDetails.refPackages || [],
            "tsk_id": _self.patDetails.refNurse,
            "tst_id": _self.patDetails.refTests || [],
            "trtmnt_id": _self.patDetails.refPhysio || [],
            'radiology':  _self.patDetails.radiology || [],
             "covid": _self.patDetails.covid || [],
             "vitamin_iv_drip": _self.patDetails.vitamin_iv_drip || [],
             "vaccination": _self.patDetails.vaccination || [],
            "hemodialysis": _self.selected,
            ref_doctorId : _self.patDetails.ref_doctorId || ''
            }
        }).then(response => {

            _self.loading = false
            if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Referred Hemodialysis Tasks successfully",
                class: "sa-a-success"
            });
            this.$parent.referHemo = false
            this.$parent.getReferralData();
            } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
                class: "sa-a-danger"
            });
            }
        })      
    }
  },
  data() {
    return {
      searchName:'',
      heamoList:[],
      selected:[],
      loader: false
    };
  },
  mounted() {
     this.selected = (this.hemo && this.hemo.length )? this.hemo: []
        let _self = this
         _self.loader = true;
        _self.$store.dispatch("httpPost", {
            uri: `${pro_url}/refer/treatmentDetails`,
            body: {
                "mtype": 9,  
                "limit": 1000,
                "page": 1,
                "name": _self.searchName,
                "prd_id":'ST034'
            }
            }).then(response => {
            if (response && response.status === 1000) {
              console.log(response,'responseresponseresponseresponse')
               _self.loader = false;
                _self.heamoList = response.data.data 
            }
        })
  }
};
</script>